import { RevButton, RevDialog } from "@revmatics/catalyst";
import { CompanyMember } from "../../../../../stores/types/companyTypes.tsx";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  invitation: CompanyMember | null;
  onConfirmDelete: () => void;
  isDeleting: boolean;
};

export const DeleteInvitationDialog = ({
  isOpen,
  setIsOpen,
  invitation,
  onConfirmDelete,
  isDeleting,
}: Props) => {
  if (!invitation) return null;

  const dialogActions = [
    <RevButton
      key="cancel"
      text="No, cancel"
      variant="secondary"
      handleClick={() => setIsOpen(false)}
    />,
    <RevButton
      key="delete"
      text="Yes, Remove"
      variant="primary"
      buttonColor="error"
      handleClick={onConfirmDelete}
      isLoading={isDeleting}
    />,
  ];

  return (
    <RevDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Are you sure you want to remove this user?"
      btnList={dialogActions}
    >
      <p className="typography-body-sm text-monochrome-900">
        They will lose all access to this company, and profile settings will be
        deleted permanently.
      </p>
    </RevDialog>
  );
};
